<template>
  <div class="register-container">
    <el-card class="register-card">
      <h2 class="register-title">用户注册</h2>
      <el-form :model="registerForm" :rules="rules" ref="registerForm" label-width="100px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="registerForm.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="userRealname">
          <el-input v-model="registerForm.userRealname" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="registerForm.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input type="password" v-model="registerForm.confirmPassword" placeholder="请确认密码"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="registerForm.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="registerForm.phone" placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item label="用户类型" prop="userType">
          <el-select v-model="registerForm.userType" placeholder="请选择用户类型">
            <el-option label="供应商" value="1"></el-option>
            <el-option label="内部用户" value="9"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-row :gutter="10">
            <el-col :span="16">
              <el-input v-model="registerForm.code" placeholder="请输入验证码"></el-input>
            </el-col>
            <el-col :span="8">
              <div class="captcha-container">
                <img :src="captchaUrl" @click="refreshCaptcha" class="captcha-img" />
              </div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleRegister" style="width: 100%" :loading="loading">注册</el-button>
        </el-form-item>
        <el-form-item>
          <div class="login-link">
            已有账号？<a href="/login" @click.prevent="$router.push('/login')">去登录</a>
          </div>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import api from '../utils/api'

export default {
  name: 'Register',
  data() {
    return {
      registerForm: {
        username: '',
        userRealname: '',
        password: '',
        confirmPassword: '',
        email: '',
        phone: '',
        userType: 9,
        code: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        userRealname: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: this.validateConfirmPassword, trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        phone: [
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
        ],
        userType: [
          { required: true, message: '请选择用户类型', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      captchaUrl: '',
      loading: false
    }
  },
  mounted() {
    this.refreshCaptcha()
  },
  methods: {
    refreshCaptcha() {
      // 使用API获取真实验证码
      api.account.getCaptcha()
        .then(res => {
          this.captchaUrl = res.data
        })
        .catch(() => {
          // 获取验证码失败，使用备用方案
          this.captchaUrl = `data:image/svg+xml;base64,${btoa(`<svg xmlns="http://www.w3.org/2000/svg" width="120" height="40" viewBox="0 0 120 40"><rect width="120" height="40" fill="#f5f7fa"/><text x="10" y="28" font-family="Arial" font-size="20" fill="#409eff">${Math.random().toString(36).substring(2, 8).toUpperCase()}</text></svg>`)}`
        })
    },
    validateConfirmPassword(rule, value, callback) {
      if (value !== this.registerForm.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    },
    handleRegister() {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          this.loading = true
          // 准备注册数据
          const registerData = {
            username: this.registerForm.username,
            userRealname: this.registerForm.userRealname,
            password: this.registerForm.password,
            email: this.registerForm.email,
            phone: this.registerForm.phone,
            userType: this.registerForm.userType,
            code: this.registerForm.code
          }
          
          api.account.register(registerData)
            .then(res => {
              this.$message.success('注册成功，请登录')
              this.$router.push('/login')
            })
            .catch(() => {
              // 注册失败，错误信息已在响应拦截器中处理
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped>
.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  position: relative;
  overflow: hidden;
}

/* 背景装饰 */
.register-container::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: move 20s linear infinite;
}

@keyframes move {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(50px, 50px);
  }
}

.register-card {
  width: 480px;
  padding: 32px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  z-index: 1;
  transition: all 0.3s ease;
}

.register-card:hover {
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
  transform: translateY(-5px);
}

.register-title {
  text-align: center;
  margin-bottom: 32px;
  color: #303133;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 1px;
}

/* 表单样式 */
.el-form {
  margin-top: 16px;
}

.el-form-item {
  margin-bottom: 16px;
}

.el-form-item__label {
  font-weight: 500;
  color: #303133;
}

.el-input,
.el-select {
  border-radius: 8px;
  transition: all 0.3s ease;
}

.el-input__inner,
.el-select__input {
  border-radius: 8px;
  height: 40px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.el-input__inner:focus,
.el-select__input.is-focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

/* 验证码样式 */
.captcha-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
}

.captcha-img {
  cursor: pointer;
  height: 40px;
  width: 100%;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.captcha-img:hover {
  transform: scale(1.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 按钮样式 */
.el-button {
  border-radius: 8px;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.el-button--primary {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

.el-button--primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

/* 登录链接 */
.login-link {
  text-align: center;
  margin-top: 16px;
  font-size: 14px;
  color: #606266;
}

.login-link a {
  color: #409eff;
  text-decoration: none;
  transition: color 0.3s ease;
}

.login-link a:hover {
  color: #66b1ff;
  text-decoration: underline;
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .register-card {
    width: 90%;
    max-width: 450px;
    padding: 24px;
  }
  
  .register-title {
    font-size: 20px;
    margin-bottom: 24px;
  }
}
</style>